import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { DashboardLayoutComponent } from "./layout/dashboard-layout/dashboard-layout.component";
import { QuickquoteLayoutComponent } from "./layout/quickquote-layout/quickquote-layout.component";
import { HttpClientModule } from "@angular/common/http";
import {
  OktaCallbackComponent,
  OKTA_CONFIG,
  OktaAuthModule
} from "@okta/okta-angular";
import { environment } from "@env";
import { OktaAuthGuard } from "./app.guard";
import { ServicingLayoutComponent } from "./layout/servicing-layout/servicing-layout.component";
import { CorrespondenceLayoutComponent } from "./layout/correspondence-layout/correspondence-layout.component";
import { CorrespondentOktaAuthGuard } from "@app/guard/correspondent-auth.guard";
import { CompanyLayoutComponent } from "./layout/company-layout/company-layout.component";
import { LoanApplicationLayoutComponent } from "./layout/loan-application-layout/loan-application-layout.component";
import {SalesLayoutComponent} from './layout/sales-layout/sales-layout.component';


const oktaConfig = {
  issuer: environment.OKTA_ISSUER,
  redirectUri: environment.OKTA_REDIRECT_URI,
  clientId: environment.OKTA_CLIENT_ID,
  pkce: true
};

const routes: Routes = [
  {
    path: "",
    redirectTo: "/servicing",
    pathMatch: "full"
  },

  {
    path: "servicing",
    component: ServicingLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/servicing/servicing.module").then(
            m => m.ServicingModule
          )
      }
    ]
  },
  {
    path: "sales",
    component: SalesLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
            import("@modules/sales/sales.module").then(
                m => m.SalesModule
            )
      }
    ]
  },
  {
    path: "company",
    component: CompanyLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/company/company.module").then(m => m.CompanyModule)
      }
    ]
  },
  {
    path: "correspondence",
    component: CorrespondenceLayoutComponent,
    canActivate: [CorrespondentOktaAuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/correspondence/correspondence.module").then(
            m => m.CorrespondenceModule
          )
      }
    ]
  },

  {
    path: "corporate",
    component: DashboardLayoutComponent,
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/lendingqb/lendingqb.module").then(
            m => m.LendingqbModule
          )
      }
    ]
  },

  {
    path: "lendingqb",
    component: DashboardLayoutComponent,
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/lendingqb/lendingqb.module").then(
            m => m.LendingqbModule
          )
      }
    ]
  },
  {
    path: "loan-application",
    component: LoanApplicationLayoutComponent,
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("@modules/loan-application/loan-application.module").then(
            m => m.LoanApplicationModule
          )
      }
    ]
  },

  {
    path: "about",
    component: QuickquoteLayoutComponent,
    loadChildren: () =>
      import("@modules/about/about.module").then(m => m.AboutModule)
  },
  {
    path: "auth",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("@modules/auth/auth.module").then(m => m.AuthModule)
  },
  {
    path: "implicit/callback",
    component: OktaCallbackComponent
  },
  // Fallback when no prior routes is matched
  { path: "**", redirectTo: "/", pathMatch: "full" }
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    OktaAuthModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled"
    })
  ],
  exports: [RouterModule],
  providers: [
    { provide: OKTA_CONFIG, useValue: oktaConfig }
    // { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ]
})
export class AppRoutingModule {}
